import { AppNS } from 'app';
import { DISCIPLINES } from 'app/main/agency/profile/qualifications-sections/sections/disciplines-picker/validation-schema';
import { Params } from 'app/types';

import { Box } from '@mui/material';

import { getDisciplinesById } from '../disciplines-picker/validation-schema';

export const SPECIAL_TEMP_TICKET_ID = 'PENDING_TICKET';

export const getListData = (data: string[], disciplines: AppNS.InspectorDiscipline[]) => {
  return data
    .map((item) => {
      return DISCIPLINES.find((d) => d.id === item);
    })
    .filter((item) => item !== undefined)
    .map((item) => {
      const discipline = disciplines.find((d) => d.name === item?.id);
      return {
        id: item?.id || '',
        name: item?.name || '',
        tooltip: (
          <Box p={0.5} fontWeight="normal">
            Discipline status: <strong>{getStateName(discipline?.state || 'draft')}</strong>
          </Box>
        ),
        classNames: getClass(discipline?.state || 'draft'),
      };
    });
};

export const getEmptyDiscipline = (name: string): AppNS.InspectorDiscipline => {
  const info = getDisciplinesById(name);
  return {
    id: '',
    name: info?.id || '',
    agencyType: info?.parent || '',
    roleType: '',
    workExperience: [],
    documents: [],
    experienceCheck: '',
    state: 'draft',
    userId: '',
    updatedAt: '',
  } as unknown as AppNS.InspectorDiscipline;
};

export const parseDisciplines = (data: AppNS.InspectorDiscipline[]): string[] => {
  if (!data) {
    return [];
  }
  return data.map((item) => getDisciplinesById(item.name)?.id || '');
};

export const prepareDisciplines = (data: string[]): Partial<AppNS.InspectorDiscipline>[] => {
  if (!data) {
    return [];
  }
  return data.map((item) => {
    const info = getDisciplinesById(item);
    return {
      name: info?.id || '',
      agencyType: info?.parent || '',
    };
  });
};

export const prepareDocuments = (data: Params): Partial<AppNS.CompanyDocument>[] => {
  return Object.keys(data).map((key) => {
    return {
      id: data[key].documents[0].documentId,
      type: key,
      certificateNumber: data[key].certificateNumber,
      expirationDate: data[key].expirationDate,
    };
  });
};

export const checkIsEditBlockedByTickets = (data: AppNS.InspectorDiscipline): boolean => {
  if (data.pendingTickets && data.pendingTickets.length > 0) {
    return data.pendingTickets.some((ticket) => ticket.doNotAllowModifications);
  }
  return false;
};

const CLASSES: Record<AppNS.InspectorDisciplineState, string> = {
  draft: 'outlined-gray flat',
  pending: 'warning flat',
  approved: 'outlined-darkblue',
  rejected: 'error-outlined flat',
  deactivated: 'error-outlined flat',
  inactive: 'error-outlined flat',
  revoked: 'error-outlined flat',
};

const DISCIPLINE_STATE: Record<AppNS.InspectorDisciplineState, string> = {
  draft: 'Draft',
  pending: 'Proposed',
  approved: 'Recognized',
  rejected: 'Rejected',
  deactivated: 'Inactive',
  inactive: 'Inactive',
  revoked: 'Revoked',
};

const getClass = (state: AppNS.InspectorDisciplineState): string => {
  return CLASSES[state] || 'warning flat';
};

const getStateName = (state: AppNS.InspectorDisciplineState): string => {
  return DISCIPLINE_STATE[state] || 'Draft';
};
